// current user circles
import { combineReducers } from 'redux';
import caregiver from './caregiver';
import memberFamilyCircle from './memberFamilyCircle';
import myFamilyCircle from './myFamilyCircle';
import leaveFamilyCircle from './leaveFamilyCircle';
import inviteToFamilyCircle from './inviteToFamilyCircle';
import acceptInviteToFamilyCircle from './acceptInviteToFamilyCircle';
import declineInviteToFamilyCircle from './declineInviteToFamilyCircle';
import inviteCaregiver from './inviteCaregiver';
import removeCaregiver from './removeCaregiver';
import acceptCaregiverRole from './acceptCaregiverRole';
import declineCaregiverRole from './declineCaregiverRole';
import acceptGuardianRole from './accept-guardian-role';
import declineGuardianRole from './decline-guardian-role';

import cancelFamilyMemberInvitation from './cancelFamilyMemberInvitation';
import cancelCaregiverInvitation from './cancelCaregiverInvitation';
import cancelGuardianInvitation from './cancel-guardian-invitation-req';
import inviteCaregiverFamily from './inviteCaregiverFamily';
import guardianCircle from './get-guardian-circle';
import inviteGuardian from './invite-guardian';
import removeGuardianRole from './remove-guardian-role';
import changeMemberRole from './change-member-role-req';
import removeAssignedProvider from './removeAssignedProvider';

export default combineReducers({
  caregiver,
  memberFamilyCircle,
  myFamilyCircle,
  inviteToFamilyCircle,
  leaveFamilyCircle,
  acceptInviteToFamilyCircle,
  declineInviteToFamilyCircle,
  inviteCaregiver,
  removeCaregiver,
  acceptCaregiverRole,
  declineCaregiverRole,
  cancelFamilyMemberInvitation,
  cancelCaregiverInvitation,
  cancelGuardianInvitation,
  inviteCaregiverFamily,
  guardianCircle,
  inviteGuardian,
  removeGuardianRole,
  acceptGuardianRole,
  declineGuardianRole,
  changeMemberRole,
  removeAssignedProvider,
});



// WEBPACK FOOTER //
// ./src/redux/circles/index.js